export default __webpack_public_path__ + "static/media/HV_Icones_Staging_dark.deaf6aed.png";